import React from "react";
import PropTypes from "prop-types";
import { 
    Result, 
    Button, 
    Icon, 
    Typography,
    Card, 
    Row, 
    Col 
} from "antd";
import keyMirror from "key-mirror";
import AddLenderForm from "../forms/add-lender";

const Paragraph = Typography.Paragraph;
const Text = Typography.Text;

class LenderOnboarding extends React.Component {
    
    sections = keyMirror({
        LANDING: null,
        ADD_FORM: null
    });

    state = {
        section: this.sections.LANDING
    }

    renderOnboaringLanding() {
        return(
            <div className="desc">
                <Paragraph>
                    <Text
                        strong
                        style={{
                            fontSize: 16,
                        }}
                    >
                        Please note following items are ready:
                    </Text>
                </Paragraph>
                <Paragraph>
                    <Icon style={{ color: "red" }} type="info" /> Your account has been frozen
                    &nbsp;<a>Thaw immediately </a>
                </Paragraph>
                <Paragraph>
                    <Icon style={{ color: "red" }} type="info" /> Your account is not yet eligible to
                    apply 
                    &nbsp;<a>Apply Unlock </a>
                </Paragraph>
            </div>
        );
    }

    renderOnboaringCreateForm() {
        return(
            <AddLenderForm />
        );
    }

    toggleSection = section => this.setState({
        section
    });

    getActiveSection() {
        if(this.state.section === this.sections.ADD_FORM) {
            return this.renderOnboaringCreateForm();
        }
        return this.renderOnboaringLanding();
    }

    getActions() {

        if(this.state.section === this.sections.ADD_FORM) {
            return [
                <Button key={"cancel"} type="default"  onClick={this.toggleSection.bind(null, this.sections.LANDING)}>
                    Cancel
                </Button>,
                <Button key={"submit"} type="primary" onClick={this.submitLenderForm}>
                    Proceed
                </Button>
            ];
        }
        return [
            <Button key={"initiate"} type="primary" onClick={this.toggleSection.bind(null, this.sections.ADD_FORM)}>
                Proceed
            </Button>
        ];
        
    }



    render() {
        return (
            <Row className={"h-100"} align={"middle"} type={"flex"}>
                <Col span={12} offset={6}>
                    <Card>
                        <Result
                            // status="info"x
                            icon={<Icon type={"bank"}/>}
                            title="Onboard a New Lender"
                            subTitle="You will be adding a new lender for credit facility"
                            extra={this.getActions()}
                        >
                            {this.getActiveSection()}
                        </Result>
                    </Card>
                </Col>
            </Row>
        );
    }
}

LenderOnboarding.propTypes = {
    route: PropTypes.object
};

export default LenderOnboarding;